/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconWarning/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaIconWarning({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconWarning",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconWarning.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Y1Kbv': alignSelf,'--mt-2-Y1Kbv': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Y1Kbv': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Y1Kbv': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Y1Kbv': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Y1Kbv': opacity,'--w-10-Y1Kbv': typeof width === 'number' ? `${width}px` : width,'--h-11-Y1Kbv': typeof height === 'number' ? `${height}px` : height,'--a-7-Y1Kbv': isAnimated ? animation : "none",'--sd-8-Y1Kbv': isAnimated ? strokeDashoffset : 0,'--sd-9-Y1Kbv': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconWarning.SvgPath"
  data-view-path={viewPath}
 d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
 style={{'--f-12-Y1Kbv': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}